import { Post } from "../utils/http.js"

export function goCheckout(params) {
  return Post('/api/order/goCheckout', params, {
    loading: true,
    shouldErrorHandler: true
  })
}

export function orderSubmit(params) {
  return Post('/api/order/orderSubmit', params, {
    loading: true,
    shouldErrorHandler: true
  })
}

export function goCheckoutV2(params, config = { loading: true, shouldErrorHandler: true }) {
  return Post('/api/order/goCheckout/v2', params, config)
}
